webpackJsonp([164232423337004],{

/***/ 1768:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ElectronicSignature","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"signature","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-electronic-signature-5dcf4e6acf5893ec8ee5.js